jQuery(document).foundation();

var mainHandler = {

	scrollBarWidth: 17,

	resizeVideoThumbnails: function() {
		// special treatment for large videos (home) and single video:
		// just make them 16:9
		var $largeVideos = jQuery('.video-large, .single-video .responsive-embed iframe');
		$largeVideos.each(function() {
			var $video = jQuery(this);
			var widthVid = parseFloat($video.width());
			$video.css({
				'min-height': (Math.ceil((widthVid * 9) / 16.0))+'px',
				'height': (Math.ceil((widthVid * 9) / 16.0))+'px',
			})
		});
		var $videos = jQuery('.video-small').not('.bigsize');
		// get standard dimensions to be applied uniformly to all thumbnails
		var standardHeight = 0;
		var standardInfoHeight = 0;
		var standardPromoHeight = 0;
		var $sampleSmallVideo = $videos.eq(0);
		var widthVid = parseFloat($sampleSmallVideo.width());
		var $infoContainer = $sampleSmallVideo
			.parents('.content-item')
			.find('.info-container');
		standardHeight = Math.ceil((widthVid * 9) / 16.0); 
		standardInfoHeight = Math.ceil($infoContainer.outerHeight() + 12); // 12 is space between thumbnail and title
		standardPromoHeight = standardHeight + standardInfoHeight;
		standardMargin = $sampleSmallVideo.parents('.content-item').outerHeight() - (standardHeight + standardInfoHeight); 
		standardBigHeight = (2 * standardHeight + standardInfoHeight + standardMargin);
		// apply standard height
		$videos.each(function() {
			var $video = jQuery(this);
			if ($video.is('.promotional-box')) {
				$video.css({
					'min-height': standardPromoHeight+'px',
					'height': standardPromoHeight+'px',
				})
			} else {
				$video.css({
					'min-height': standardHeight+"px",
					'height': standardHeight+"px",
				});	
			}
		});
		// height of bigsize thumbnail is twice of the normal one
		jQuery('.video-small.bigsize').each(function() {
			var $video = jQuery(this);
			if (Foundation.MediaQuery.atLeast('medium')) {
				$video.css({
					'min-height': standardBigHeight+"px",
					'height': standardBigHeight+"px",
				});		
			} else {
				$video.css({
					'min-height': standardHeight+"px",
					'height': standardHeight+"px",
				});	
			}
		});
	
	},

	resizeTimer: null,

	handleResize: function() {
		var self = this;
		clearTimeout(this.resizeTimer);
		this.resizeTimer = setTimeout(function() {
			self.resizeVideoThumbnails();
		}, 100);
	},

	hideAllFloatingPanels : function(removeScroll = true) {
		jQuery('.action-panel')
			.removeClass('is-shown')
			.css({'right': '-100%'});
		jQuery('body').removeClass('disable-scroll');
		
		if (jQuery('.mobile-menu-panel').is('.opened')) {
			jQuery('.mobile-menu-toggle-close').toggleClass('opened');
			jQuery('.mobile-menu-panel').toggleClass('opened');
		}
	},
	
	openPanel : function($panel) {
		if ($panel.length == 0) return;
		if (!$panel.is('.action-panel')) return;
		if ($panel.is('.is-shown')) {
			$panel.removeClass('is-shown');
			setTimeout(function() {
				$panel.css({'right': '-100%'});
			}, 250); // match 250 with panel's animation duration
		} else {
			this.hideAllFloatingPanels();
			$panel.css({'right': 0});
			$panel.addClass('is-shown');
		}
		jQuery("body").toggleClass('disable-scroll');
		if (jQuery("body").is('.disable-scroll')) {
			jQuery("body").css({'padding-right': this.scrollBarWidth+'px'});
		} else {
			jQuery("body").css({'padding-right': 0});
		}
	},

	getScrollBarWidth: function() {
		var $outer = $('<div>').css({visibility: 'hidden', width: 100, overflow: 'scroll'}).appendTo('body'),
				widthWithScroll = $('<div>').css({width: '100%'}).appendTo($outer).outerWidth();
		$outer.remove();
		this.scrollBarWidth = 100 - widthWithScroll;
	},
		
}

jQuery(document).ready(function($) {
	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		$(this).parent().addClass('responsive-embed widescreen')
	});

	$(window).on('resize', function() {
		mainHandler.handleResize();
	}).trigger('resize');

	mainHandler.getScrollBarWidth();
	mainHandler.hideAllFloatingPanels();
	mainHandler.resizeVideoThumbnails();
	var hash = window.location.hash;
	mainHandler.openPanel($(hash+'-panel'));

	//$('.action-panel').css({height: window.innerHeight});

	// about panel
	var $aboutPanel = $("#about-panel");
	$('body').on("click", '[href="#about-panel"], [href="#about"]', function(e) {
		e.preventDefault();
		e.stopPropagation();
		mainHandler.openPanel($aboutPanel);
	})

	// subscribe panel
	var $subscribePanel = $("#subscribe-panel");
	$('body').on("click", '[href="#subscribe-panel"], [href="#subscribe"]', function(e) {
		e.preventDefault();
		e.stopPropagation();
		mainHandler.openPanel($subscribePanel);
	})

	// support panel
	var $supportPanel = $("#support-panel");
	$('body').on("click", '[href="#support-panel"], [href="#support"]', function(e) {
		e.preventDefault();
		e.stopPropagation();
		mainHandler.openPanel($supportPanel);
	})		

	// sms pannel
	var $smsPanel = $("#sms-panel");
	$('body').on("click", '[href="#sms-panel"], [href="#sms"]', function(e) {
		e.preventDefault();
		e.stopPropagation();
		mainHandler.openPanel($smsPanel);
	})
})
